import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const getOnChange = ({
  setProductSKU,
  onChange,
  sku,
  skuSize,
}) => () => {
  setProductSKU(sku);
  if (onChange) {
    onChange({
      skuSize,
      sku,
    });
  }
};

const generateSizeClassNames = ({ availableQuantity }) => (
  classNames(
    'product-radio__size',
    {
      'product-radio__size--out-of-stock': availableQuantity === 0,
    },
  )
);

const ProductSwatchSizesItemMarkup = ({
  swatches,
  selectedSKU,
  setProductSKU,
  onChange,
}) => (
  Array.isArray(swatches) && (
    <ul className="product-radio">
      {swatches.map(({ sku, skuSize, availableQuantity }) => (
        <li className="product-radio__input-list-item" key={sku}>
          <input
            aria-label={sku}
            type="radio"
            id={sku}
            name="product-radio-selector"
            className="product-radio__input"
            checked={sku === selectedSKU}
            onChange={getOnChange({
              setProductSKU,
              onChange,
              sku,
              skuSize,
            })}
          />
          <label
            data-test="product-swatch-colours-item"
            htmlFor={sku}
            className="product-radio__label"
          >
            <div className={generateSizeClassNames({ availableQuantity })}>{skuSize}</div>
          </label>
        </li>
      ))}
    </ul>
  )
);

ProductSwatchSizesItemMarkup.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    // TODO: [2] define proper shape structure for swatch object
    sku: PropTypes.string.isRequired,
    skuColor: PropTypes.string,
  })).isRequired,
  setProductSKU: PropTypes.func,
  selectedSKU: PropTypes.string.isRequired,
};

export default ProductSwatchSizesItemMarkup;
